import { createMuiTheme } from '@material-ui/core/styles';

const MyTheme = createMuiTheme({
    palette: {
      primary: {
        main: "#F0002C",
      },
      secondary: {
        main: "#00e773",
      },
    },
    typography: {
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 12,
    },


    
  });

  MyTheme.typography.h1 = {
    padding: 5,
    paddingTop:20,
    fontWeight: "bold",

    fontSize: '1rem',
    fontFamily: "'Open Sans', sans-serif",
    '@media (min-width:600px)': {
      fontSize: '1rem',
    },
    [MyTheme.breakpoints.up('md')]: {
      fontSize: '2rem',
    },
  };
  MyTheme.typography.h5 = {
    fontSize: '0.8rem',
    fontFamily: "'Open Sans', sans-serif",
    '@media (min-width:600px)': {
      fontSize: '0.8rem',
    },
    [MyTheme.breakpoints.up('md')]: {
      fontSize: '1rem',
    },
  };

 /*  MyTheme.typography.h6 = {
    fontSize: '0.9em',
    fontWeight: "normal",
    lineHeight: "1em",
    fontFamily: "'Open Sans', sans-serif",
    '@media (min-width:600px)': {
      fontSize: '0.7rem',
    },
    [MyTheme.breakpoints.up('md')]: {
      fontSize: '0.9rem',
    },
  }; */

 /*  MyTheme.typography.subtitle1 = {
    fontSize: '1.3em',
    fontFamily: "'Open Sans', sans-serif",
    '@media (min-width:600px)': {
      fontSize: '1rem',
    },
    [MyTheme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
    },
  };

  MyTheme.typography.subtitle2 = {
    fontSize: '1em',
    lineHeight: "1em",
    fontFamily: "'Open Sans', sans-serif",
    '@media (min-width:600px)': {
      fontSize: '0.5rem',
    },
    [MyTheme.breakpoints.up('md')]: {
      fontSize: '1rem',
    },
  };

  MyTheme.typography.body1 = {
    fontSize: '1em',
    lineHeight: "1em",
    fontFamily: "'Open Sans', sans-serif",
    '@media (min-width:600px)': {
      fontSize: '1rem',
    },
    [MyTheme.breakpoints.up('md')]: {
      fontSize: '1rem',
    },
  };

  MyTheme.typography.caption = {
    fontSize: '3em',
    fontFamily: "'Open Sans', sans-serif",
    '@media (min-width:600px)': {
      fontSize: '3rem',
    },
    [MyTheme.breakpoints.up('md')]: {
      fontSize: '4rem',
    },
  };
 */
export default MyTheme;
